import { subDays } from "date-fns";

export type RangePreset = "30d" | "90d" | "1y" | "all";

export const PRESET_LABELS: Record<RangePreset, string> = {
  "30d": "30d",
  "90d": "90d",
  "1y": "1y",
  all: "All",
};

export const PRESET_DAYS: Record<Exclude<RangePreset, "all">, number> = {
  "30d": 30,
  "90d": 90,
  "1y": 365,
};

/** Compute `from` date from a preset. Used by consuming components. */
export function getFromDate(preset: RangePreset, anchor: Date): Date {
  if (preset === "all") return new Date(0);
  return subDays(anchor, PRESET_DAYS[preset]);
}
